<template>
  <div>
    <b-card title="Selecciona los datos">

      <!-- form -->
      <validation-observer ref="simpleRules">

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group label="Clínica">
                <validation-provider
                  #default="{ errors }"
                  name="Clínica"
                  rules="required"
                >
                  <b-form-select
                    v-model="assignment.clinic_id"
                    :options="clinics"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Odontólogo">

                <validation-provider
                  #default="{ errors }"
                  name="Odontólogo"
                  rules="required"
                >
                  <b-form-select
                    v-model="assignment.dentist_id"
                    :options="dentists"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                variant="success"
                type="submit"
              >
                Asignar Odontólogo
              </b-button>
            </b-col>
          </b-row>
        </b-form>

      </validation-observer>

    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BFormInput, BRow, BCol, BFormGroup, BCardText, BButton, BCard, BForm, BFormSelect, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from 'axios'
import api from '@/plugin/axios'

export default {
  components: {
    BFormGroup,
    BRow,
    BCol,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BForm,
    BFormSelect,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      assignment: {
        clinic_id: '',
        dentist_id: '',
      },
      clinics: [],
      dentists: [],
    }
  },
  async created() {
    const [response] = await Promise.all([
      api.get('/api/clinic-dentists/create'),
    ])

    console.log(response.data.clinics, response.data)

    this.clinics = response.data.clinics.map(clinic => ({ value: clinic.id, text: clinic.user.full_name }))
    this.dentists = response.data.dentists.map(dentist => ({ value: dentist.id, text: dentist.full_name }))
    console.log('pruebas', this.clinics)
  },
  methods: {
    async submitForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            const response = await api.post('/api/clinic-dentists', this.assignment)
            this.$router.go(0)
            this.$bvToast.toast('Odontólogo asignado con éxito', { variant: 'success' })
            this.$bvToast.toast('Odontólogo asignado con éxito', {
              title: '¡Exitosamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })
          } catch (error) {
            this.$bvToast.toast('Error al asignar el odontólogo', {
              title: '¡Error!', // Título del toast
              variant: 'danger', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })
            // this.$bvToast.toast('Error al asignar el odontólogo', { variant: 'danger' })
          }
        }
      })
    },
  },
}
</script>
